import { Home } from "../../pages";

export const NotFound = () => {
    if (window.location.pathname.match(/\.(pdf|jpg|png|css|js)$/)) {
        window.location.href = window.location.pathname;
        return null;
    }
    return <Home />;
};